export function useSite() {
  const siteName = useState('siteName', () => 'CRM')

  return {
    siteName,
  }
}
